import type { Row } from "./Manifests";

import { paperworkManifestId } from "./shippingPaperworkColumns";

/**
 * The manifest ids a bulk action may run on, out of a grid selection.
 *
 * Two reductions, both required. The merged grid keys rows by the composite
 * `<kind>:<entity id>`, which no manifest mutation or authorizer accepts, so
 * the entity id is read off the row's populated manifest side instead. And a
 * bill-of-lading row has no manifest at all, so it drops out rather than
 * reaching an action that would look it up in the manifest table.
 */
export function selectedManifestIds(rows: Row[]): string[] {
  return rows.map((row) => paperworkManifestId(row)).filter((id): id is string => id !== null);
}
